import React, { useState, useEffect } from 'react';
import { useTimeAttendanceListFetch } from '../../hooks/useTimeAttendanceListFetch';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import API from '../../API'
import Knoppie from '../Knoppie';
import Spinner from '../Spinner';
import './TimeAttendanceList.css';
import Header from '../Header';
import ButtonGrid from '../ButtonGrid';

const TimeAttendanceList = () => {
  const auth = useAuth();
   const location = useLocation();
  const from = location.state?.from || './'
  const [startDate, setStartDate] = useState(() => {
    let currDate = new Date();
    return new Date(currDate.getFullYear(), currDate.getMonth() - 1, 22).toISOString().slice(0, 10);
  });

  const [endDate, setEndDate] = useState(() => {
    let currDate = new Date();
    return new Date(currDate.getFullYear(), currDate.getMonth(), 22).toISOString().slice(0, 10);
  });

  // Fetch attendance whenever startDate or endDate changes
  const { timeAttendancestate, timeAttendanceloading,fetchTimeAttendanceList } = useTimeAttendanceListFetch(startDate, endDate);
  const navigate = useNavigate()
  const [sortedList, setSortedlist] = useState([]);
  const [datesList, setDatesList] = useState([]);

  console.log(timeAttendancestate)

  const handleDelete = async (e) => {

    console.log("gekliek op delete " + e)

    try {

      // eslint-disable-next-line no-restricted-globals
      const confirmation = confirm(`Are you sure you want to Delete this clocking ${e}? This action cannot be overturned!`)
      if(confirmation){



      console.log("Sukses, die clocking gaan delete word hier")
      await API.deleteTimeAttendance(e,auth.auth.accessToken)

      fetchTimeAttendanceList()
      
    }else{
      return
    }
    } catch (error) {
        console.log(error)
    }
        
    console.log("gekliek op" + e)
    console.log(auth.auth.user.username)



  }

  const handleDeleteWholeDay = async (date) => {

      console.log(date)

      try {

      // eslint-disable-next-line no-restricted-globals
      const confirmation = confirm(`Are you sure you want to Delete ${date}? This action cannot be overturned!`)
      if(confirmation){



      console.log("Sukses, die clocking gaan delete word hier")
      await API.deleteTimeAttendanceDate(date,auth.auth.accessToken)

      fetchTimeAttendanceList()
      
    }else{
      return
    }
    } catch (error) {
        console.log(error)
    }




  }

  const months = ["January","February","March","April","May","June","July","August","September","October","November","December"]
 const weekdays = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]

  useEffect(() => {
    const employeeClockIns = {};
    const dateSet = new Set();

    var totalhours = 0
    timeAttendancestate.timeAttendances.forEach(record => {
      

      
      const employeeId = record.employee?._id;
      const employeeName = record.employee?.givname;
      const employeeSurname = record.employee?.surname;
      const recordDate = new Date(record.date).toISOString().split("T")[0];

      const clockIn = record.clockInTime ? new Date(record.clockInTime) : null;
      const clockOut = record.clockOutTime ? new Date(record.clockOutTime) : null;

      const normalhours = record.paytype?.factor===1 && clockIn && clockOut ? ((clockOut - clockIn) / (1000 * 60 * 60)).toFixed(2) : "N/A";
      const overtime15 = record.paytype?.factor===1.5 && clockIn && clockOut ? ((clockOut - clockIn) / (1000 * 60 * 60)).toFixed(2) : "N/A";
      const overtime175 = record.paytype?.factor===1.75 && clockIn && clockOut ? ((clockOut - clockIn) / (1000 * 60 * 60)).toFixed(2) : "N/A";
      const overtime2 = record.paytype?.factor===2.0 && clockIn && clockOut ? ((clockOut - clockIn) / (1000 * 60 * 60)).toFixed(2) : "N/A";
      const hours = clockIn && clockOut ? ((clockOut - clockIn) / (1000 * 60 * 60)).toFixed(2) : "N/A";
      

      dateSet.add(recordDate);

      if (!employeeClockIns[employeeId]) {
        employeeClockIns[employeeId] = {

          name: employeeName,
          surname: employeeSurname,
          totalhours: 0,
          overtime15: 0,
          overtime175: 0,
          overtime2:0,
          attendance: [],
        };
      }
      employeeClockIns[employeeId].totalhours = normalhours!=="N/A"?employeeClockIns[employeeId].totalhours+Number(normalhours):employeeClockIns[employeeId].totalhours;
      employeeClockIns[employeeId].overtime15 = overtime15!=="N/A"?employeeClockIns[employeeId].overtime15+Number(overtime15):employeeClockIns[employeeId].overtime15;
      employeeClockIns[employeeId].overtime175 = overtime175!=="N/A"?employeeClockIns[employeeId].overtime175+Number(overtime175):employeeClockIns[employeeId].overtime175;
      employeeClockIns[employeeId].overtime2 = overtime2!=="N/A"?employeeClockIns[employeeId].overtime2+Number(overtime2):employeeClockIns[employeeId].overtime2;
      employeeClockIns[employeeId].attendance.push({_id: record._id, ...record,hours});
    });

    setSortedlist(Object.values(employeeClockIns).sort((a, b) => (a.surname || "").localeCompare(b.surname || "")));
    setDatesList([...dateSet].sort());
  }, [timeAttendancestate]);


  console.log(sortedList)

  return (
    <>
      <Header destination={from} />

      <ButtonGrid>

        <Knoppie
            clickable={true}
            text={"New Clocking"}
            destination={"../Clockings"}
            from={'../TimeAttendanceList'}
        />


      <div className="date-picker">
        <label>Choose date range here</label>
        <div>
          <label>Start date</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div>
          <label>End date</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      </div>
      </ButtonGrid>

      {timeAttendanceloading && <Spinner />}

      {sortedList.length===0 ? 
          <div className='date-picker'>No Clockings recorded for this time period yet.</div>
        :
        <>
        { <div className="table-container">
          <table className="attendance-table">
            <thead>
              <tr>
                <th>Name</th>
                {datesList.map((date, index) => (
                  <th key={index} className="date">
                    <div className='delete-btn' id={index} onClick={(e) => { e.stopPropagation(); handleDeleteWholeDay(date) }}>x</div>
                    <div>{weekdays[new Date(date).getDay()]}</div>
                    <div>{months[new Date(date).getMonth()]}</div>
                    <div className="date-circle">{new Date(date).getDate()}</div>
                 
                  
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              
              {sortedList.map((log, idx) => (
                <tr key={idx} className="employee-row">
                  <td className="employee-name">
                    {log.name + " " + log.surname}
                    <div className="normal-hours">Normal hours: {log.totalhours}</div>
                    <div className="normal-hours">{log.overtime15!==0?`Overtime @ 1.5: ${log.overtime15}`:""}</div>
                    <div className="normal-hours">{log.overtime175!==0?`Overtime @ 1.75: ${log.overtime175}`:""}</div>
                    <div className="normal-hours">{log.overtime2!==0?`Overtime @ 2: ${log.overtime2}`:""}</div>
                  </td>
                  
                  {datesList.map((date) => (
                   
                   <td key={date} >
    
                      {log.attendance.map((clocking)=>(
    
                        <>
                       {new Date(clocking?.date).toISOString().slice(0, 10)===new Date(date).toISOString().slice(0, 10)?
                        <div className={new Date(date).getDay() === 6 || new Date(date).getDay() === 0 ? 'Weekend' : 'ClockContainer'}>
                          <div className='delete-btn' id={clocking._id} onClick={(e) => { e.stopPropagation(); handleDelete(clocking._id) }}>x</div>
                          <div id={clocking._id} className='SingleClocking' onClick={(e) => { navigate(`../Clocking/${clocking._id}`, { state: { from: './TimeAttendanceList' } }) }}>
                            <div className="normal-hours">
                              In: {new Date(clocking.clockInTime).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                            </div>
                            <div className="normal-hours">
                              Out: {new Date(clocking.clockOutTime).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                            </div>
                            <div className="normal-hours">{clocking?.paytype?.description}</div>
                            
                           
                            <div>{clocking.hours}</div>
                            
                          </div>
                        </div>
                        :""}
                      </>
    
                      ))}
                      
                    </td>
                  ))}
                  
                </tr>
              ))}
            </tbody>
          </table>
          </div> }
          </>
        }



      
    </>
  );
};

export default TimeAttendanceList;
